import { useState, useEffect } from "react";
import { useWebsite } from "../../../context/WebsiteContext";

import { WebInput, WebButton } from "./shared";

export default function Default() {
  const { currentURL, setPageTitle, setPageIcon } = useWebsite();

  useEffect(() => {
    setPageTitle("About The Internet");
    setPageIcon(undefined);
  }, [currentURL, setPageTitle, setPageIcon]);

  return (
    <div
      style={{
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "16px",
        width: "250px",
        padding: "8px",
        paddingTop: "16px",
        paddingBottom: "16px",
        backgroundImage: "url(./backgrounds/starry.jpg)",
        backgroundRepeat: "repeat",
        backgroundAttachment: "scroll",
      }}
    >
      <div style={{ fontSize: "14px", textAlign: "center", color: "white" }}>
        The internet is currently being built and will be available shortly within the next few
        decades.
      </div>
      <img
        src="./the-internet.png"
        alt="Internet Map"
        style={{ maxWidth: "350px", border: "2px solid white" }}
      />
    </div>
  );
}
